var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIconMonotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2912_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22L6 22L6 6L22 6L22 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 22L26 22V6L42 6V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 42H26V26L42 26V42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 42H6L6 26L22 26L22 42Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2912_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIconMonotone);
export default __webpack_public_path__ + "static/media/microsoft_icon_monotone.7f6eef25604ce98e04952d872bfd02c4.svg";
export { ForwardRef as ReactComponent };